import * as React from 'react';

interface FeatureWrapperProps {
    className: string;
    children: React.ReactNode;
    dimensions?: number; // this is sent by ReflexElement
}

export default class FeatureWrapper extends React.PureComponent<FeatureWrapperProps> {
    render(): React.ReactElement {
        const { children, dimensions, className } = this.props;
        const childrenWithWidth = React.Children.map(children, (child: React.ReactElement) => {
            const newProps = { ...child.props, dimensions };
            return React.cloneElement(child, newProps);
        });
        return (
            <div className={className}>
                {childrenWithWidth}
            </div>
        );
    }
}
